export enum ICompanyTransKind {
    None = 0,
    PublicAndCar = 1,
}